import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const { scheduleAppointment } = importer('APIs/appointments', null)
const AppointmentsActions = importer('Stores/Appointments/Actions')
const { tokens } = importer('Stores/Users/Select', null)

export default function * main ({ startDateTime, appointmentType, donorSfid, numberOfChildren, centerSfid, createdFrom }) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`

    yield put(AppointmentsActions.scheduleAppointmentLoading())
    const res = yield scheduleAppointment(startDateTime, appointmentType, donorSfid, numberOfChildren, centerSfid, createdFrom, token)

    /* Note: with PD-3036 API will be returning status 200 when the business logic fails,
    example: if user already have a appoinment and tries to book another appoinment*/
    // if the response have error code then call the appointment failure
    if(res.data?.code){
      yield put(AppointmentsActions.scheduleAppointmentFailure(res.data))
    } 
    // if the response does not have a error object then consider it as a success
    else{
      yield put(AppointmentsActions.scheduleAppointmentSuccess(res))
    }
  } catch (error) {
    yield put(AppointmentsActions.scheduleAppointmentFailure(error))
  }
}
